import { KDateFormat, KDateParse } from '@kiwid-app/kiwid-date-typescript';
import { DATE_API } from 'app/core/const/date.const';
import { Util } from 'app/core/helpers/util';

export function formatDate(date: Date, format: string = DATE_API): string {
    return KDateFormat(date, format, { lang: Util.currentLang() });
}

export function parseDate(date: string, format = DATE_API): Date {
    return KDateParse({ value: date, format });
}

export function parseDateWithTime(date: string): Date {
    return new Date(date);
}
